import type { IconProps } from './types';

export const HelpCircleIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
    >
      <path
        d="M8.71875 10.125V9.65625C8.71875 7.84406 10.1878 6.375 12 6.375C13.8122 6.375 15.2812 7.84406 15.2812 9.65625V10.125L12 12.9375V15.2812"
        stroke={color}
        strokeWidth="1.5"
      />
      <path d="M12 16.6875V18.5625" stroke={color} strokeWidth="1.5" />
      <path
        d="M1.6875 12C1.6875 14.7351 2.774 17.3581 4.70797 19.2921C6.64193 21.226 9.26496 22.3125 12 22.3125C14.7351 22.3125 17.3581 21.226 19.2921 19.2921C21.226 17.3581 22.3125 14.7351 22.3125 12C22.3125 9.26496 21.226 6.64193 19.2921 4.70797C17.3581 2.774 14.7351 1.6875 12 1.6875C9.26496 1.6875 6.64193 2.774 4.70797 4.70797C2.774 6.64193 1.6875 9.26496 1.6875 12Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};
